export const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // background: '#f2f2f2',
    border: "2px solid #e2e8f0",
    boxShadow: 24,
    height: "calc(100vh - 90px)",
    width: "calc(100vw - 100px)",
    p: 4,
};

export const heatmapContainerStyle = {
    overflow: "auto", // Enable scrolling
    maxHeight: "calc(100vh - 100px)", // Maximum height of the modal content
    maxWidth: "calc(100vw - 100px)", // Maximum width of the modal content
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};

export const closeBtnStyle = {
    position: "absolute",
    top: "1.5rem",
    left: "80%",
    color: "#2196F3",
    backgroundColor: "white",
    borderColor: "rgba(63, 81, 181, 0.5)",
    border: "1px solid",
    boxShadow: "none",
}